import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import { observer } from 'mobx-react';
import { GetStartedTaskContainer } from 'owa-get-started';
import strings from 'owa-strings/owa-getstarted-strings';
import { logUsage } from 'owa-analytics';
var GetStartedPane = /** @class */ (function (_super) {
    tslib_1.__extends(GetStartedPane, _super);
    function GetStartedPane(props) {
        return _super.call(this, props) || this;
    }
    GetStartedPane.prototype.render = function () {
        var _this = this;
        logUsage('getStartedPaneOpened');
        return (React.createElement(HeaderFlexPane, { title: strings.getStarted_FlexPane_Title, content: React.createElement(GetStartedTaskContainer, null), onDismiss: function () {
                _this.props.onDismiss();
            } }));
    };
    GetStartedPane = tslib_1.__decorate([
        observer
    ], GetStartedPane);
    return GetStartedPane;
}(React.Component));
export default GetStartedPane;
//# sourceMappingURL=GetStartedPane.js.map